/**
 * Sanitizer brought over from https://github.com/calm/api/tree/master/libraries/sanitizer
 */

import type { SECURE_KEY } from './keys';
import { SECURE_KEY_LIST, SECURE_KEY_MAP } from './keys';
import { Validator } from './validator';

export function sanitizingStringifyReplacer(): (
    key: string | undefined | null,
    value: any
) => any {
    const seen = new WeakSet();
    return (key, value) => {
        if (value instanceof RegExp) {
            value = value.toString();
        }

        if (!key && value !== null && typeof value === 'string') {
            // root item passed was a string
            const lowered = (value ?? '').toLowerCase();
            for (let i = 0; i < SECURE_KEY_LIST.length; i++) {
                if (lowered.includes(SECURE_KEY_LIST[i])) {
                    return '<SANITIZED>';
                }
            }
        }

        if (typeof value === 'object' && value != null) {
            if (seen.has(value)) {
                return '<CIRCULAR>';
            }
            seen.add(value);
        }
        const secureKey = (key ?? '').toLowerCase() as SECURE_KEY;
        // if the normalized key exists in the block map replace it with <SANITIZED>
        // otherwise allow the original key
        if (SECURE_KEY_MAP[secureKey]) {
            return '<SANITIZED>';
        }
        // check all strings for email addresses
        if (
            typeof value === 'string' &&
            value.includes('@') &&
            Validator.validate('email', value)
        ) {
            return value.replace(
                /\b[!#$%&'*+\-/=?^_`{|}~a-zA-Z0-9.]+@[a-zA-Z0-9.-]+\b/g,
                '<SANITIZED>@<SANITIZED>'
            );
        }
        return value;
    };
}
